import React, { useEffect, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import PrivacyPolicyRoute from "../Common/PrivacyPolicyRoute";

const SectionGetQuoteForm = () => {
  const [address, setAddress] = useState({ label: "" });
  const [dyClass, setDyClass] = useState(false);
  const [addressLabel, setAddressLabel] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fromUrl, setFromUrl] = useState<string>("");
  const [frmUrl, setfrmUrl] = useState<string>("");
  const [addressInfo, setAddresInfo] = useState({
    streetAddress: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    latlong: {},
  });

  const [averageMonthlyBill, setAverageMonthlyBill] = useState("");

  const [errorMsg, setErrorMsg] = useState<any>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    average_monthly_bill: "",
    address: "",
    addressValidationCheck: "default",
  });

  useEffect(() => {
    if (window != undefined) {
      setFromUrl(window.location.href);
      setfrmUrl(window.location.origin);
    }
  });
  const styleOnfun = () => {
    setDyClass(true);
  };

  const styleOnBlr = (event: any) => {
    setDyClass(false);
    handleInputChange(event, "address");
  };

  const selectAddress = (e: any) => {
    setAddress(e);
    setAddressLabel(e.label);
    let zipcode: any = null;
    let state: any = null;
    let streetAddress: any = null;
    let country: any = null;
    let city: any = null;
    geocodeByAddress(e.label)
      .then((results) => {
        let place: any = results[0];
        for (var i = 0; i < place.address_components.length; i++) {
          for (var j = 0; j < place.address_components[i].types.length; j++) {
            if (place.address_components[i].types[j] == "postal_code") {
              zipcode = place.address_components[i].long_name;
            }
            if (
              place.address_components[i].types[j] ==
              "administrative_area_level_1"
            ) {
              state = place.address_components[i].short_name;
            } else if (
              place.address_components[i].types[j] == "street_number"
            ) {
              streetAddress = place.address_components[i].long_name;
            } else if (place.address_components[i].types[j] == "route") {
              streetAddress = `${streetAddress} ${place.address_components[i].long_name}`;
            } else if (
              place.address_components[i].types[j] == "locality" ||
              place.address_components[i].types[j] == "sublocality"
            ) {
              city = place.address_components[i].long_name;
            } else if (place.address_components[i].types[j] == "country") {
              country = place.address_components[i].long_name;
            }
          }
        }
        return getLatLng(results[0]);
      })
      .then(({ lat, lng }) => {
        if (state && city && country) {
          setErrorMsg({ ...errorMsg, address: "" });
          setAddresInfo({
            streetAddress: streetAddress || "",
            city: city,
            state: state,
            zipcode: zipcode,
            country: country,
            latlong: { lat, lng },
          });
        } else {
          setErrorMsg({ ...errorMsg, address: "Invaild  address" });
        }
      });
  };

  const setAddressValidationCheck = () => {
    setErrorMsg((currentValue: any) => {
      if (currentValue.addressValidationCheck) {
        setErrorMsg({ ...errorMsg, addressValidationCheck: "" });
      }
      return currentValue;
    });
  };

  const validation = () => {
    if (
      !(
        errorMsg.first_name ||
        errorMsg.last_name ||
        errorMsg.email ||
        errorMsg.average_monthly_bill ||
        errorMsg.address
      )
    ) {
      if (errorMsg.addressValidationCheck) {
        return false;
      } else {
        if (
          !(
            errorMsg.first_name ||
            errorMsg.last_name ||
            errorMsg.email ||
            errorMsg.average_monthly_bill
          ) &&
          firstName &&
          lastName &&
          averageMonthlyBill &&
          email
        ) {
          if (!addressLabel) {
            return true;
          }
          return false;
        }
      }
    } else {
      if (
        errorMsg.first_name ||
        errorMsg.last_name ||
        errorMsg.email ||
        errorMsg.average_monthly_bill ||
        errorMsg.address
      ) {
        return true;
      }
      return false;
    }
  };

  const handleInputChange = (event: any, type: string) => {
    const value = event.target.value;
    switch (type) {
      case "first_name":
        if (!value || !new RegExp(/^[A-Za-z]+$/).test(value)) {
          if (!value)
            setErrorMsg({ ...errorMsg, first_name: "Please enter first name" });
          else setErrorMsg({ ...errorMsg, first_name: "Invalid first name" });
        } else {
          setErrorMsg({ ...errorMsg, first_name: "" });
          setAddressValidationCheck();
        }
        break;
      case "last_name":
        if (!value || !new RegExp(/^[A-Za-z]+$/).test(value)) {
          if (!value)
            setErrorMsg({ ...errorMsg, last_name: "Please enter last name" });
          else setErrorMsg({ ...errorMsg, last_name: "Invalid last name" });
        } else {
          setErrorMsg({ ...errorMsg, last_name: "" });
          setAddressValidationCheck();
        }
        break;
      case "email":
        if (
          !value ||
          !new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ).test(value)
        ) {
          if (!value)
            setErrorMsg({ ...errorMsg, email: "Please enter email address" });
          else setErrorMsg({ ...errorMsg, email: "Invalid email address" });
        } else {
          setErrorMsg({ ...errorMsg, email: "" });
          setAddressValidationCheck();
        }
        break;
      case "phone":
        if (
          !value ||
          !new RegExp(
            /^\+?([0-9\s\-\(\)]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/
          ).test(value)
        ) {
          if (!value) setErrorMsg({ ...errorMsg, phone: "Please enter phone" });
          else setErrorMsg({ ...errorMsg, phone: "Invalid Phone number" });
        } else {
          setErrorMsg({ ...errorMsg, phone: "" });
          setAddressValidationCheck();
        }
        break;
      case "average_monthly_bill":
        if (value == "default") {
          setErrorMsg({
            ...errorMsg,
            average_monthly_bill: "Please select average monthly bill",
          });
        } else {
          setErrorMsg({ ...errorMsg, average_monthly_bill: "" });
          setAddressValidationCheck();
        }
        break;

      case "address":
        setAddress((currentValue: any) => {
          if (!currentValue.label)
            setErrorMsg({ ...errorMsg, address: "Please select address" });
          else setErrorMsg({ ...errorMsg, address: "" });
          setAddressValidationCheck();
          return currentValue;
        });
        break;
    }
  };
  const [toggleMainText, setToggleMainText] = useState<any>(false);

  const toggleLessMore = () => {
    setToggleMainText(!toggleMainText);
  };
  return (
    <form
      id="contacts"
      className="md:py-8 py-6 px-4 md:px-10"
      action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
      method="POST"
      data-netlify="true"
    >
      <input
        id="lead_source"
        name="lead_source"
        type="hidden"
        value="SolarQuote"
        aria-label="lead_source"
      />

      <input
        name="retURL"
        type="hidden"
        value={`${frmUrl}/thankYou`}
        aria-label="retURL"
      />

      <input
        id="url"
        name="url"
        type="hidden"
        value={frmUrl}
        aria-label="url"
      />

      <input type="hidden" id="country_code" name="country_code" value="US" />

      <input
        type="hidden"
        id="zip"
        name="zip"
        value={addressInfo?.zipcode || ""}
      />

      <input
        type="hidden"
        id="state_code"
        name="state_code"
        value={addressInfo?.state || ""}
      />

      <input
        type="hidden"
        id="city"
        name="city"
        value={addressInfo?.city || ""}
      />

      <input
        type="hidden"
        id="street"
        name="street"
        value={addressInfo?.streetAddress || ""}
      />

      <input
        name="address"
        id="address"
        required
        type="hidden"
        value={addressLabel}
      />

      <input
        name="oid"
        id="field1"
        type="hidden"
        value="00D8Z000000sT5h"
        aria-label="oid"
      />

      <input
        type="hidden"
        id="00N8Z000009sTfB"
        name="00N8Z000009sTfB"
        value={fromUrl || ""}
      />
      <input
        type="hidden"
        id="00N8Z000009sUDc"
        name="00N8Z000009sUDc"
        value="Quote Form"
      />
      {/* 
        <input name="debug" type="hidden" value="1" />
                  <input name="debugEmail" type="hidden" value="manoj@expansionjs.com" /> */}

      <div className="">
        <h3 className="text-2xl md:text-2xl xl:text-3xl text-titleColor font-primarySemiBold mb-6">
          {" "}
          Get Started Now
        </h3>

        <div className="grid grid-cols-2 gap-4">
          <div className="relative mb-7">
            <svg
              className="absolute left-0 top-3 mx-3 xxs:w-7 xxs:h-7 w-6 h-6 text-gray-400 object-contain"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              ></path>
            </svg>
            <input
              name="first_name"
              type="text"
              id="first_name"
              value={firstName}
              onChange={(event) => {
                setFirstName(event.target.value),
                  handleInputChange(event, "first_name");
              }}
              onBlur={(event) => {
                handleInputChange(event, "first_name");
              }}
              required
              placeholder="First Name"
              title="First Name"
              className="text-sm xxs:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none pl-12 pr-3 p-3 border border-gray-300 w-full placeholder-current text-bodyColor rounded"
            />
            {errorMsg.first_name && (
              <span className="text-red-500 text-xs absolute -bottom-5 left-1 w-full">
                {errorMsg.first_name}
              </span>
            )}
          </div>
          <div className="relative mb-7">
            <svg
              className="absolute left-0 top-3 mx-3 xxs:w-7 xxs:h-7 w-6 h-6 text-gray-400 object-contain"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              ></path>
            </svg>
            <input
              name="last_name"
              type="text"
              id="last_name"
              required
              placeholder="Last Name"
              value={lastName}
              onChange={(event) => {
                setLastName(event.target.value),
                  handleInputChange(event, "last_name");
              }}
              onBlur={(event) => {
                handleInputChange(event, "last_name");
              }}
              title="Last Name"
              className="text-sm xxs:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none pl-12 pr-3 p-3 border border-gray-300 w-full placeholder-current text-bodyColor rounded"
            />
            {errorMsg.last_name && (
              <span className="text-red-500 text-xs absolute -bottom-5 left-1 w-full">
                {errorMsg.last_name}
              </span>
            )}
          </div>
        </div>

        <div className="relative ">
          <div
            className={
              dyClass
                ? "input-focus focus:ring-offset-primary focus:outline-none focus:ring-2 focus:ring-titleColor relative  pl-10  border border-gray-300 w-full placeholder-current text-bodyColor rounded bg-white"
                : "focus:ring-offset-primary focus:outline-none focus:ring-2 focus:ring-titleColor relative  pl-10  border border-gray-300 w-full placeholder-current text-bodyColor rounded bg-white"
            }
          >
            <svg
              className="absolute left-0 top-3 mx-3 xxs:w-7 xxs:h-7 w-6 h-6 text-gray-400 object-contain"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              ></path>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              ></path>
            </svg>
            {/* <svg className="absolute left-0 top-2 xxs:top-3 w-7 h-7 text-gray-300 object-contain px-1 xxs:px-0 mx-1 xxs:mx-3 " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg> */}
            <GooglePlacesAutocomplete
              apiKey={process.env.GOOGLE_ADDRESS_API_KEY}
              autocompletionRequest={{
                componentRestrictions: {
                  country: "us",
                },
              }}
              selectProps={{
                inputId: "landingAddress",
                address,
                onChange: selectAddress,
                placeholder: "Address",
                onFocus: styleOnfun,
                onBlur: styleOnBlr,
                innerProps: { id: "landingAddress" },
              }}
            />
          </div>
        </div>

        <div className="relative  my-7">
          <img
            src="/images/amount-icon.png"
            alt=""
            className="absolute xxs:w-7 xxs:h-7 w-6 h-6 left-0 top-3 mx-3 object-contain "
          />
          <select
            required
            value={averageMonthlyBill}
            onChange={(event) => {
              setAverageMonthlyBill(event.target.value),
                handleInputChange(event, "average_monthly_bill");
            }}
            onBlur={(event) => {
              handleInputChange(event, "average_monthly_bill");
            }}
            id="average_monthly_bill"
            name="Average_Electric_Bill__c"
            title="Average Bill"
            className="xxs:mb-0 mb-3 rounded appearance-none text-sm xxs:text-base 2xl:text-lg focus:outline-none pl-12 pr-3 p-3 border border-gray-300 w-full placeholder-current text-bodyColor"
          >
            <option value="">Average Monthly Bill</option>
            <option value="0-100">0-100</option>
            <option value="100-200">100-200</option>
            <option value="200-400">200-400</option>
            <option value="400+">400+</option>
          </select>
          {errorMsg.average_monthly_bill && (
            <span className="text-red-500 text-xs absolute -bottom-5 left-1 w-full">
              {errorMsg.average_monthly_bill}
            </span>
          )}
        </div>

        <div className="relative  mb-7">
          <svg
            className="absolute left-0 top-3 mx-3 xxs:w-7 xxs:h-7 w-6 h-6 text-gray-400 object-contain"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
          <input
            name="email"
            type="text"
            id="email"
            required
            placeholder="Email Address"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value), handleInputChange(event, "email");
            }}
            onBlur={(event) => {
              handleInputChange(event, "email");
            }}
            title="Enter Email"
            className="rounded text-sm xxs:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none pl-12 pr-3 p-3 border border-gray-300 w-full placeholder-current text-bodyColor"
          />
          {errorMsg.email && (
            <span className="text-red-500 text-xs absolute -bottom-5 left-1 w-full">
              {errorMsg.email}
            </span>
          )}
        </div>

        <div className="relative  mb-7">
          <svg
            className="absolute left-0 top-3 mx-3 xxs:w-7 xxs:h-7 w-6 h-6 text-gray-400 object-contain"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            ></path>
          </svg>

          {/* <svg className="absolute left-0 top-3 mx-3 w-7 h-7 text-gray-400 object-contain" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg> */}
          <input
            name="phone"
            type="text"
            id="mobile"
            required
            placeholder="Phone Number"
            value={phone}
            onChange={(event) => {
              setPhone(event.target.value), handleInputChange(event, "phone");
            }}
            onBlur={(event) => {
              handleInputChange(event, "phone");
            }}
            title="Enter Email"
            className="rounded text-sm xxs:text-base focus:ring-2 focus:ring-titleColor focus:ring-offset-white  focus:outline-none pl-12 pr-3 p-3 border border-gray-300 w-full placeholder-current text-bodyColor"
          />
          {errorMsg.phone && (
            <span className="text-red-500 text-xs absolute -bottom-5 left-1 w-full">
              {errorMsg.phone}
            </span>
          )}
        </div>

        <button
          disabled={validation()}
          type="submit"
          className="disabled:opacity-10 block p-3 w-full mt-2 rounded-full bg-primary shadow-lg text-white text-base 2xl:text-lg font-primaryRegular uppercase text-center"
        >
          Get Quote
        </button>

        <div className="font-primaryLight text-xs text-gray-400 mt-4">
          <span className="font-primaryBold italic">
            We will not sell your information.
          </span>{" "}
          <br />
          By submitting this form, you consent to receive emails, text messages
          and phone calls at any phone number you provide, even if the number is
          a wireless number.&nbsp;
          {!toggleMainText && (
            <span
              onClick={() => toggleLessMore()}
              className="cursor-pointer relative inline-flex"
            >
              <span className="font-primaryRegular text-primary opacity-70">
                Read more
              </span>
            </span>
          )}
          {toggleMainText && (
            <span className="text-xs">
              You agree that such calls and texts may be made using automated
              technology and that you are not required to provide consent to
              these calls to make a purchase from us.&nbsp;
              <span
                onClick={() => toggleLessMore()}
                className="cursor-pointer relative inline-flex"
              >
                <span className="font-primaryRegular text-primary opacity-70">
                  Read less
                </span>
              </span>
            </span>
          )}
          <PrivacyPolicyRoute />
        </div>
      </div>
    </form>
  );
};
export default SectionGetQuoteForm;
